// extracted by mini-css-extract-plugin
export default {"semester":"SemesterBox_semester__-v06l"};